(function () {
    'use strict';

    angular
        .module('app.user')
        .controller('OnBoardController', OnBoardController);
    /*jshint -W071, -W072 */
    /* @ngInject */
    function OnBoardController(
        logger,
        userOnBoardingService,
        userService,
        applicationService,
        $uibModalInstance,
        $q, $timeout, roleService,
        autocarSiteService, customerService,
        $filter, currentUser, user, settings) {

        //Private Variables
        var vm = this;
        vm.model = userOnBoardingService.getDefaultUserPrivileges();

        //Public Variables
        vm.title = 'Elevate Privileges';
        vm.user = user || null;
        vm.settings = settings || null;
        vm.isValid = false;

        //Public Methods
        vm.reset = reset;
        vm.refresh = refresh;
        vm.save = save;
        vm.onValidationChanged = onValidationChanged;

        //Activate Controller
        activate();

        function activate() {
            if (user === null || settings === null) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        //Public Methods
        function reset() {
            $uibModalInstance.dismiss('cancel');
        }

        //hack to make the multiple selects update the input width
        function refresh() {
            $timeout(function () { }, 50);
        }

        function save() {
            if (!!vm.model.CustomerSiteId) {
                customerService.getCorporateForSites(vm.model.CustomerSiteId, 6)
                    .then(function (result) {
                        if (result.length > 0) {
                            vm.model.CorporateCustomerId = result[0].ParentCustomerId;
                        }

                        userOnBoardingService.saveUserPrivileges(vm.model).then(function (results) {
                            $uibModalInstance.close(vm.model);

                        });
                    });           
            } else {
                userOnBoardingService.saveUserPrivileges(vm.model).then(function (results) {
                    $uibModalInstance.close(vm.model);
                });
            }
        }

        function onValidationChanged(validationStatus) {
            vm.isValid = validationStatus;
        }
    }
})();
